import { element as ngElement } from 'angular';
import { isNumber } from './utilities/is-number';
import './slick';
var defaultAutoPlaySpeed = 3000;
var defaultAnimationSpeed = 300;
var defaultTouchThreshold = 5;
export var SlickDirective = [
    '$timeout',
    function ($timeout) {
        return {
            link: function ($scope, element, attributes) {
                var isInitialized;
                var destroySlick = function () {
                    return $timeout(function () {
                        var slider = ngElement(element);
                        slider.slick('unslick');
                        slider.slick('getSlick')
                            .lazyLoad();
                        slider.find('.slick-list,[tabindex]')
                            .remove();
                        slider.off('init afterChange loading stopLoading');
                        return slider;
                    });
                };
                var initializeSlick = function () {
                    return $timeout(function () {
                        var currentIndex;
                        var slider = ngElement(element);
                        if (isNumber($scope.currentIndex)) {
                            currentIndex = $scope.currentIndex;
                        }
                        var customPaging = function (slick, index) {
                            return $scope.customPaging({ index: index, slick: slick });
                        };
                        slider.on('loading', function () {
                            slider.height(slider.outerHeight());
                        });
                        slider.on('stopLoading', function () {
                            $timeout(function () {
                                slider.height('auto');
                            });
                        });
                        slider.on('init', function (_, slick) {
                            if (attributes.onInit) {
                                $scope.onInit();
                            }
                            if (isNumber(currentIndex)) {
                                return slick.slideHandler(currentIndex);
                            }
                            return true;
                        });
                        slider.on('beforeChange', function () {
                            if ($scope.onBeforeChange) {
                                $scope.onBeforeChange();
                            }
                        });
                        slider.on('afterChange', function (_event, _slick, currentSlide) {
                            if ($scope.onAfterChange) {
                                $scope.onAfterChange();
                            }
                            if (isNumber(currentIndex)) {
                                return $scope.$apply(function () {
                                    currentIndex = currentSlide;
                                    return ($scope.currentIndex = currentSlide);
                                });
                            }
                        });
                        slider.slick({
                            accessibility: $scope.accessibility !== 'false',
                            adaptiveHeight: $scope.adaptiveHeight === 'true',
                            appendArrows: $scope.appendArrows ? $($scope.appendArrows) : $(element),
                            appendDots: $scope.appendDots ? $($scope.appendDots) : $(element),
                            arrows: $scope.arrows !== 'false',
                            asNavFor: $scope.asNavFor ? $scope.asNavFor : void 0,
                            autoplay: $scope.autoplay === 'true',
                            autoplaySpeed: $scope.autoplaySpeed ? parseInt($scope.autoplaySpeed, 10) : defaultAutoPlaySpeed,
                            beforeChange: attributes.onBeforeChange ? $scope.onBeforeChange : void 0,
                            centerMode: $scope.centerMode === 'true',
                            centerPadding: $scope.centerPadding || '50px',
                            cssEase: $scope.cssEase || 'ease',
                            customPaging: attributes.customPaging ? customPaging : void 0,
                            dots: $scope.dots === 'true',
                            draggable: $scope.draggable !== 'false',
                            easing: $scope.easing || 'linear',
                            fade: $scope.fade === 'true',
                            focusOnSelect: $scope.focusOnSelect === 'true',
                            infinite: $scope.infinite !== 'false',
                            initialSlide: $scope.initialSlide || 0,
                            lazyLoad: $scope.lazyLoad || 'ondemand',
                            nextArrow: $scope.nextArrow ? $($scope.nextArrow) : void 0,
                            onReInit: attributes.onReInit ? $scope.onReInit : void 0,
                            onSetPosition: attributes.onSetPosition ? $scope.onSetPosition : void 0,
                            pauseOnHover: $scope.pauseOnHover !== 'false',
                            prevArrow: $scope.prevArrow ? $($scope.prevArrow) : void 0,
                            responsive: $scope.responsive || void 0,
                            rtl: $scope.rtl === 'true',
                            slide: $scope.slide || 'div',
                            slidesToScroll: $scope.slidesToScroll ? parseInt($scope.slidesToScroll, 10) : 1,
                            slidesToShow: $scope.slidesToShow ? parseInt($scope.slidesToShow, 10) : 1,
                            speed: $scope.speed ? parseInt($scope.speed, 10) : defaultAnimationSpeed,
                            swipe: $scope.swipe !== 'false',
                            swipeToSlide: $scope.swipeToSlide === 'true',
                            touchMove: $scope.touchMove !== 'false',
                            touchThreshold: $scope.touchThreshold ? parseInt($scope.touchThreshold, 10) : defaultTouchThreshold,
                            useCSS: $scope.useCSS !== 'false',
                            variableWidth: $scope.variableWidth === 'true',
                            vertical: $scope.vertical === 'true',
                        });
                        return $scope.$watch('currentIndex', function (newVal) {
                            if (isNumber(currentIndex) && isNumber(newVal) && newVal !== currentIndex) {
                                return slider.slick('slickGoTo', newVal);
                            }
                        });
                    });
                };
                $scope.$watch('loading', function () {
                    if ($scope.loading === undefined) {
                        return false;
                    }
                    ngElement(element)
                        .trigger($scope.loading === true ? 'loading' : 'stopLoading');
                    return $scope.loading;
                });
                if ($scope.initOnload) {
                    isInitialized = false;
                    return $scope.$watch('data', function (newVal) {
                        if (typeof newVal === 'undefined') {
                            return false;
                        }
                        if (isInitialized) {
                            destroySlick();
                        }
                        initializeSlick();
                        return (isInitialized = true);
                    });
                }
                else {
                    initializeSlick();
                    isInitialized = true;
                }
            },
            restrict: 'E',
            scope: {
                accessibility: '@',
                adaptiveHeight: '@',
                appendArrows: '@',
                appendDots: '@',
                arrows: '@',
                asNavFor: '@',
                autoplay: '@',
                autoplaySpeed: '@',
                centerMode: '@',
                centerPadding: '@',
                cssEase: '@',
                currentIndex: '=',
                customPaging: '&',
                data: '=',
                dots: '@',
                draggable: '@',
                easing: '@',
                fade: '@',
                focusOnSelect: '@',
                infinite: '@',
                initOnload: '@',
                initialSlide: '@',
                lazyLoad: '@',
                loading: '=',
                nextArrow: '@',
                onAfterChange: '&',
                onBeforeChange: '&',
                onInit: '&',
                onReInit: '&',
                onSetPosition: '&',
                pauseOnDotsHover: '@',
                pauseOnHover: '@',
                prevArrow: '@',
                responsive: '=',
                rtl: '@',
                slide: '@',
                slidesToScroll: '@',
                slidesToShow: '@',
                speed: '@',
                swipe: '@',
                swipeToSlide: '@',
                touchMove: '@',
                touchThreshold: '@',
                useCSS: '@',
                variableWidth: '@',
                vertical: '@',
            },
        };
    },
];
